<template>
    <div>
        <el-dialog title="导入学校名单" :visible.sync="showImport" top="2vh" center :before-close="handleClose">
            <div style="margin: 0 auto;text-align: center">
                <el-radio-group v-model="register_type" @input="changeType">
                    <el-radio-button label="1">私有账号注册</el-radio-button>
                    <el-radio-button label="2">公有账号注册</el-radio-button>
                </el-radio-group>
            </div>
            <el-form>
                <el-form-item label="从Excel文件导入名单">
                    <br/>
                    <el-upload
                            class="upload-demo"
                            action="''"
                            multiple
                            :limit="1"
                            :http-request="importFile"
                            :before-upload="beforeImport"
                            :file-list="fileList"
                    >
                        <el-button size="small" type="primary">导入文件</el-button>
                        <el-button slot="tip" style="margin-left: 20px" size="small" type="text"  @click="exportExample()">下载导入模板</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传 xlsx/xls/csv 文件，且不超过500kb</div>
                        <!-- <div slot="tip" v-if="register_type==1">导入的Excel文件确保第一列为 真实姓名 第二列为 手机号 第三列为教师教授科目</div>
                        <div slot="tip" v-if="register_type==2">导入的Excel文件确保第一列为 真实姓名 第二列为教师教授科目</div> -->
                    </el-upload>
                </el-form-item>

                <el-form-item label="学校名单:">
                    <el-input type="textarea" @change="formatImportText" v-model="importText" placeholder='请将内容复制输入到此'
                              size="medium" rows="10"
                              autocomplete="off">
                    </el-input>
                    <div v-if="register_type==1">
                        <b>温馨提示：</b><br/>
                        1.手动输入时，“真实姓名+手机号”形式，用逗号分隔。<b style="color: #F56C6C;">真实姓名不要带符号，例如（）、？、/、￥以及空格等</b> <br>
                        2.一次最多导入 100 个账号<br>
                        3.真实姓名和手机号都为必填项
                    </div>
                    <div v-if="register_type==2">
                        <b>温馨提示：</b><br/>
                        1.手动输入时，<b style="color: #F56C6C;">真实姓名不要带符号，例如（）、？、/、￥以及空格等</b><br>
                        2.一次最多导入 100 个账号
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleImportText" :disabled="importText == ''" :loading="submiting">导入名单</el-button>
            </div>
        </el-dialog>


        <el-dialog :title="register_type == 1 ? '注册私有账号' : '注册公有账号'" :visible="showForm" :before-close="handleClose" width="60%" top="5vh">

            <el-alert v-show="showWarning"
                title="数据异常警告"
                description='"红色背景" 的数据为真实姓名或者手机号出现重复，
                下面列表中 "黄色背景" 的数据为手机号已存在，
                "灰色背景" 的数据为真实姓名已存在，请手动将其移除或更改'
                type="warning" 
                show-icon>
            </el-alert>

            <el-alert v-show="msg != ''"
                      :title="msg"
                      :type="msgType" 
                      show-icon>
            </el-alert>

            <!-- <el-form ref="form" :inline="true" label-width="120px">
                <el-form-item label="设置账号前缀">
                    <el-input v-model="accountPrefix" size="small" :clearable="true" placeholder="输入账号前缀"></el-input>
                </el-form-item>
            </el-form> -->

            <el-button size="mini" type="danger" @click="removeAccounts">批量移除</el-button>

            <el-table
                    :data="accounts.filter(account => !search || account.real_name.toLowerCase().includes(search.toLowerCase()))"
                    style="width: 100%"
                    height="500"
                    :row-class-name="tableRowClassName"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column align="center" type="selection"></el-table-column>
                <el-table-column type="index" width="50"></el-table-column>
                <!-- <el-table-column label="用户名" prop="username" v-if="register_type == 2">
                    <template slot-scope="scope">
                        {{accountPrefix}}{{scope.row.username}}
                    </template>
                </el-table-column> -->
                <el-table-column label="真实姓名" prop="real_name">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.real_name" size="mini" placeholder="输入真实姓名"/>
                    </template>
                </el-table-column>
                <el-table-column label="手机号" prop="mobile" v-if="register_type==1">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.mobile" size="mini" placeholder="输入手机号"/>
                    </template>
                </el-table-column>
                <el-table-column label="登录密码" prop="password" v-if="register_type==2">
                    <template slot="header" slot-scope="scope">
                        <el-input v-model="batchPassword" size="mini" placeholder="输入批量设置密码"/>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.password" size="mini" placeholder=""/>
                    </template>
                </el-table-column>
                <el-table-column align="right">
                    <template slot="header" slot-scope="scope">
                        <el-input v-model="search" size="mini" placeholder="输入姓名搜索过滤"/>
                    </template>
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="removeAccount(scope.row)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog
                    width="50%"
                    title="系统提示"
                    :visible.sync="innerVisible"
                    append-to-body
                    top="25vh"
                    center
            >
                <el-alert title='警告: 系统检测到以下账号对应手机号已存在其他学校,继续注册将会被强行转校,并将其从其他学校移除,该操作存在一定风险,会导致这些账号在原学校使用的服务不可用,如果不确定请点击取消,将其从账号列表中移除再注册.'
                          type="error"></el-alert>
                <br/>

                <el-table :data="existUsers" style="width: 100%" border size="mini">
                    <el-table-column prop="name" label="真实姓名"></el-table-column>
                    <el-table-column prop="mobile" label="手机号"></el-table-column>
                    <el-table-column prop="customer_name" label="已绑学校"></el-table-column>
                    <el-table-column prop="username" label="已绑用户名"></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="innerVisible = false">取消</el-button>
                    <el-button size="small" type="primary" @click="handleEnforceBatchRegister" :loading="submiting">我已了解其中风险,并继续执行注册
                    </el-button>
                </div>
            </el-dialog>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submiting">确 定</el-button>
            </div>
        </el-dialog>


        <!--账号注册成功,但是短信发送失败的-->
        <el-dialog title="短信发送失败的账号" :visible.sync="showFailForm" :show-close="false" :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <el-table :data="sms_fail">
                <el-table-column prop="real_name" label="真实姓名"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="address" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="handleSendPassword(scope.row)">重新发送</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>

</template>

<style>
    .el-table .warning-row {
        background: #FAECD8;
    }

    .el-table .success-row {
        background: #E1F3D8;
    }

    .el-table .error-row {
        background: #FDE2E2;
    }

    .el-table .info-row {
        background: #C0C4CC;
    }
</style>

<script>

    import AccountService from "~/services/CustomerAccounts";
    import CustomerService from "~/services/customer";
    import {Regexp} from "~/config/params";
    import Excel from 'xlsx'
    import Function from "~/common/functions";
    import CommonService from "~/services/common";

    const MAX_ACCOUNT_TOTAL = 500;
    const REGISTER_TYPE_MOBILE = 1;
    const REGISTER_TYPE_FIX_NAME = 2;

    const make_cols = refstr => Array(Excel.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
        name: Excel.utils.encode_col(i),
        key: i
    }));


    // 批量注册账号组件
    export default {
        name: "RegAccounts",
        props: {
            display: {
                type: Boolean,
                default: false
            },
            customer: {
                type: Object,
                default: null
            },
        },

        data() {
            return {

                fileList: [],

                // 显示导入窗口
                showImport: false,
                // 显示批量注册信息窗口
                showForm: false,
                importText: '',
                accounts: [],
                search: '',
                batchPassword: '',
                batchIdentity: '',
                identities: AccountService.getIndentify(),
                submiting: false,

                msg: '',
                msgType: 'error',

                // 记录错误的表格行用于标红
                errorRows: [],

                // 将会被忽略的记录
                ignoreRows: [],
                // 将会被覆盖修改的记录
                updateRows: [],

                // 通过姓名获取到的服务端已经存在的记录
                serverData: {},

                loading: false,
                showWarning: false,
                register_type: '1',
                sheetData: [], //Excel 表格数据
                sheetColumns: [], // Excel 表格中的列

                sms_fail: [],//注册成功,但发送短信失败的
                showFailForm: false,

                // 账号前缀
                accountPrefix: '',
                // 选中表格中的数据容器
                selections: [],
                innerVisible: false,

                // 已存在用户数据容器
                existUsers: [],
                // 已存在其他学校的手机号容器
                existMobiles: [],
            };
        },
        created() {
            this.showImport = this.display;
            if (this.customer.id > 0) {
                this.getCustomerPrefix();
            }
        },
        watch: {
            showImport: function (value, original) {
                if (value == false) {
                    this.importText = '';
                }
            },

            batchPassword: function (value, original) {
                if (value !== original) {
                    this.accounts.forEach((val, key) => {
                        this.accounts[key]['password'] = value;
                    })
                }
            },

            batchIdentity: function (value, original) {
                if (value !== original) {
                    this.accounts.forEach((val, key) => {
                        this.accounts[key]['identity'] = value;
                    })
                }
            },

            sheetData: function (value, original) {
                if (value.length > 0) {
                    this.joinImportText();
                }
            }
        },
        methods: {

            exportExample() {
                let url = 'https://scrm.21cnjy.net/api/customer/accounts/example-export';
                let params = {'register_type': this.register_type};
                Function.exportFile(url,params );
                return false;
            },
            getCustomerPrefix() {
                CustomerService.getInfo(this.customer.id).then(res => {
                    if (res && res.code == 0) {
                        let customer = res.data;
                        this.accountPrefix = customer.prefix;
                    }
                }).catch(err => {
                    console.error(err)
                });
            },

            formatImportText(text) {
                if (text == '') {
                    return '';
                }

                // 替换制表符
                text = text.replace(/\t/g, ",");
                text = text.replace(/\s\r/g, "");
                text = text.replace(/ /ig, "");

                // 替换中文逗号
                text = text.replace(/，/ig, ",");
                // 不同的中文逗号
                //text = text.replace("，", ",");

                this.importText = text;
            },


            beforeImport(file) {
                let index = file.name.lastIndexOf(".");
                let ext = file.name.substr(index + 1);
                let allowExt = ['xlsx', 'xls', 'csv'];
                if (allowExt.indexOf(ext) < 0) {
                    this.$message.error("只支持上传 xlsx/xls/csv 等格式文件");
                    return false;
                }

                const isLt2M = file.size / 1024 < 500;
                if (!isLt2M) {
                    this.$message.error('导入文件大小不能超过 500 KB !');
                    return false;
                }

                return true;
            },

            /**
             * 导入文件
             * @param param
             */
            importFile(param) {
                this.sheetData = [];
                this.importText = '';
                let file = param.file;
                let rf = new FileReader();
                rf.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target.result;

                    const wb = Excel.read(bstr, {type: 'binary'});

                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data = Excel.utils.sheet_to_json(ws, {header: 1});
                    /* Update state */
                    const cols = make_cols(ws['!ref']);

                    this.sheetData = data;
                    this.sheetColumns = cols;
                };

                rf.readAsBinaryString(file);
            },

            joinImportText() {
                if (this.sheetData.length == 0) {
                    return;
                }

                let importText = '';
                this.sheetData.forEach((value, index) => {
                   if(value[0] == '真实姓名') //过滤掉真实姓名
                   {
                       return;
                   }
                    let text = '';
                    if (value[0] && value[0] != '') {
                        let name = value[0];
                        if (typeof name !== 'string') {
                            this.fileList = [];
                            this.sheetData = [];
                            this.$message.error('导入的数据格式不正确，请求修正后再重新导入');
                            return;
                        }
                        text = text + name.replace(/\s/g, '');
                    }


                    if (value[1] && value[1] != '') {
                        let mobile = value[1].toString();
                        text = text + ',' + mobile.replace(/\s/g, '');
                    }
                    if (value[2] && value[2] != '') {
                        let chid = value[2].toString();
                        text = text + ',' + chid.replace(/\s/g, '');
                    }

                    if (value[0] == '姓名' || value[1] == '手机'|| value[2] == '学科') {
                        importText += '';
                    } else {
                        importText += text + '\n';
                    }

                })
                if (this.importText == '') {
                    this.importText = importText;
                } else {
                    this.importText += '\n' + importText;
                }
            },

            // 处理导入
            async handleImportText() {

                let context = this.importText;

                if (context == '') {
                    return;
                }

                let accounts = context.split("\n");

                if (accounts.length < 1) {
                    this.$message.error('导入的数据格式不正确，请求修正后再重新导入');
                    return;
                }

                this.submiting = true;
                let data = [];

                let hasError = false;


                let allNames = [];
                let allMobiles = [];
                let allchids = [];
                let errorMessage = ''
                accounts.forEach((val, key) => {
                    // 切割姓名手机号
                    let account = val.split(",");
                    // 直接过滤名字为空的记录
                    if (!account[0] || account == '') { `xd`
                        return;
                    }
                    if(this.register_type == 1) {
                       // 验证手机号
                       if (account[1] && !Regexp.mobile.test(account[1])) {
                           errorMessage += account[0] + ' 手机号 ' + account[1] + ' 填写有误<br>';
                       }
                    }
                    let username = account[0];
                    allNames.push(account[0]);
                    if(this.register_type == 1) {
                        if (account[1]) {
                            allMobiles.push(account[1]);
                        }
                    }
                    if(this.register_type == 1) {
                        data.push({
                            username: username,
                            real_name: account[0],
                            mobile: account[1] ? account[1] : '',
                            customer_id: this.customer.id,
                            identity: "1",
                            password: ''
                        });
                    }else{
                        data.push({
                            username: username,
                            mobile:'',
                            real_name: account[0],
                            customer_id: this.customer.id,
                            identity: "1",
                            password: ''
                        });
                    }

                })
                if(errorMessage != '') {
                    this.$message({dangerouslyUseHTMLString:true,message:errorMessage,type:'error'});
                    hasError = true;
                    this.submiting = false;
                    return;
                }

                if (data.length > MAX_ACCOUNT_TOTAL) {
                    this.$message.error('一次最多支持注册' + MAX_ACCOUNT_TOTAL + '个账号');
                    this.submiting = false;
                    return;
                }
                if (allNames.length > 0) {
                    this.getPreview({
                        customer_id: this.customer.id,
                        real_names: allNames,
                        mobiles: allMobiles,
                        chids: allchids
                    })
                }

                if (hasError) {
                    this.submiting = false;
                    return;
                }
                if (data.length > 0) {
                    this.accounts = data;
                }

                this.showImport = false;
                this.showForm = true;
                this.submiting = false;
            },

            removeAccount(account) {
                this.$confirm("确定要移除改条记录？", "温馨提示", {type: "warning"}).then(ok => {
                    this.accounts.splice(this.accounts.indexOf(account), 1);
                }).catch(cancel => {
                    return false;
                });
            },
            tableRowClassName({row}) {
                const rowIndex = this.accounts.indexOf(row);
                // 给手机号错误的记录背景标红
                if (this.errorRows.indexOf(row.mobile) !== -1) {
                    return 'error-row';
                }

                // 给姓名错误的记录背景标红
                if (this.errorRows.indexOf(row.real_name) !== -1) {
                    return 'error-row';
                }

                // 检查是否有重复的真实姓名和手机号
                const isDuplicate = this.accounts.some((r, index) => {
                    // 只有在值非空时才检查重复
                    const namesDuplicate = row.real_name && r.real_name && index !== rowIndex && r.real_name === row.real_name;
                    const mobilesDuplicate = row.mobile && r.mobile && index !== rowIndex && r.mobile === row.mobile;
                    return namesDuplicate || mobilesDuplicate;
                });
                // 如果有重复，返回特定的类名
                if (isDuplicate) {
                    return 'error-row';
                }

                // 给手机号已在其他学校注册绑定的记录背景标红
                if (row.mobile && this.existMobiles.indexOf(row.mobile) !== -1) {
                    return 'warning-row';
                }

                if (row.real_name && this.serverData && this.serverData[row.real_name]) {
                    return 'info-row';
                }
                return '';
            },

            getPreview(params) {
                this.loading = true;
                AccountService.getPreview(params).then(res => {
                    this.existMobiles = [];
                    if (res.code == 0 && res.data != null) {
                        res.data.forEach((val, key) => {
                            this.serverData[val.real_name] = val;
                            this.existMobiles.push(val.mobile);
                        });
                        this.isAllRowsWhite();
                    }
                    this.loading = false;
                }).catch(err => {
                    console.error(err)
                })
            },

            setMessage(msg, type = 'error') {
                this.msg = msg;
                this.msgType = type;
            },

            submitForm() {
                // let names = [];
                // let mobiles = [];
                // this.accounts.forEach(account => {
                //     if (account.real_name) {
                //         names.push(account.real_name);
                //     }
                //     if (account.mobile) {
                //         mobiles.push(account.mobile);
                //     }
                // });
                // this.getPreview({
                //     customer_id: this.customer.id,
                //     real_names: names,
                //     mobiles: mobiles,
                //     chids: []
                // })
                
                if(!this.isAllRowsWhite()){
                    this.$message({message:'请先把表格的警告数据修改完善后再提交', type:'error'});
                    return false;
                }
                this.submiting = true;
                CustomerService.checkPrefix({
                    customer_id: this.customer.id,
                    prefix: this.accountPrefix
                }).then(res => {
                    if (res.code == 4220) {
                        this.$confirm("前缀 " + this.accountPrefix + " 已被使用过，" +
                            "继续注册可能会导致用户名被加上随机数用来避免账号重复，是否确定要继续强制注册账号？", "温馨提示", {type: "warning"}).then(ok => {
                            this.setPrefix();
                        }).catch(cancel => {
                            this.submiting = false;
                            return false;
                        });
                        return;
                    } else {
                        this.setPrefix();
                    }
                    return;

                })


            },

            setPrefix() {
                CustomerService.setPrefix({
                    id: this.customer.id,
                    prefix: this.accountPrefix
                }).then(res => {
                    if (res.code == 0) {
                        // this.$message({
                        //     message:'前缀设置成功',
                        //     type:'success'
                        // });
                        this.handleBatchRegister();
                    }
                }).catch(cancel => {
                    this.submiting = false;
                });
            },

            // 处理批量注册
            handleBatchRegister() {


                let allNames = [];
                this.errorRows = [];

                let hasError = false;

                // 过滤排查重复姓名
                for (var key in this.accounts) {
                    if (allNames.indexOf(this.accounts[key].real_name) == -1) {
                        allNames.push(this.accounts[key].real_name);
                    } else {
                        this.errorRows.indexOf(this.accounts[key].real_name) == -1 && this.errorRows.push(this.accounts[key].real_name);
                    }
                }

                if (this.errorRows.length > 0) {
                    this.submiting = false;
                    this.setMessage('以下数据 姓名为: ' + this.errorRows.join(',') + ' 的记录出现重复请改正后再提交');
                    return;
                }


                // 处理手机号重复
                let allMobiles = [];

                for (var key in this.accounts) {

                    // 直接过滤手机号为空的记录
                    if (!this.accounts[key].mobile || this.accounts[key].mobile == '') {
                        continue;
                    }

                    if (allMobiles.indexOf(this.accounts[key].mobile) == -1) {
                        allMobiles.push(this.accounts[key].mobile);
                    } else {
                        this.errorRows.indexOf(this.accounts[key].mobile) == -1 && this.errorRows.push(this.accounts[key].mobile);
                    }
                }

                if (this.errorRows.length > 0) {
                    this.submiting = false;
                    this.setMessage('以下数据 手机号: ' + this.errorRows.join(',') + ' 的记录出现重复, 请改正后再提交');
                    return;
                }


                // 错误的的真实姓名记录
                let emptyNames = [];
                // 错误的手机号记录
                let mobileRows = [];
                // 错误的身份记录
                let identityRows = [];

                for (var key in this.accounts) {

                    if (this.accounts[key].real_name == '') {
                        emptyNames.push(this.accounts[key].real_name);
                    }

                    if (this.accounts[key].identity < 1) {
                        identityRows.push(this.accounts[key].real_name);
                    }

                    // if (this.accounts[key].mobile != '' && !Regexp.mobile.test(this.accounts[key].mobile)) {
                    //     mobileRows.push(this.accounts[key].real_name);
                    // }
                    // 主要修改点：只在手机号不为空时验证格式，以及只在是手机号注册类型时验证手机号是否必填
                    if (this.register_type == REGISTER_TYPE_MOBILE &&
                        (!this.accounts[key].mobile || this.accounts[key].mobile == '')) {
                        // 仅当是手机号注册类型且手机号为空时记录错误
                        mobileRows.push(this.accounts[key].real_name);
                    } else if (this.accounts[key].mobile != '' && !Regexp.mobile.test(this.accounts[key].mobile)) {
                        // 如果手机号不为空但格式不正确
                        mobileRows.push(this.accounts[key].real_name);
                    }

                }

                if (emptyNames.length > 0) {
                    this.errorRows = emptyNames;
                    this.submiting = false;
                    this.setMessage('以下标红的数据存在真实姓名为空的情况，请修正后再提交');
                    return;
                }

                if (identityRows.length > 0) {
                    this.errorRows = identityRows;
                    this.submiting = false;
                    this.setMessage('以下标红的数据存在身份信息为空或无效的情况，请修正后再提交');
                    return;
                }

                    if (mobileRows.length > 0) {
                        this.errorRows = mobileRows;
                        this.submiting = false;
                        this.setMessage('以下标红的数据存在手机号为空或格式不正确，请修正后再提交');
                        return;
                    }

                // 主要修改点：删除了以下重复的验证代码，因为已经在上面处理过了,留下反而会有bug
                // if (this.register_type == REGISTER_TYPE_MOBILE) {
                //     let filter = this.accounts.filter(i => {
                //         return !i.mobile;
                //     });
                //     if (filter.length > 0) {
                //         let i = filter.reduce((i, b) => {
                //             return i.concat(b.real_name);
                //         }, []);
                //         this.errorRows = i;
                //         this.submiting = false;
                //         this.setMessage('以下标红的用户【' + i.join('、') + '】手机号不能为空，请填写后再提交');
                //         return false;
                //     }
                // }
                this.msg = '';

                this.submiting = true;
                this.accounts = this.accounts.map(i => {
                    i.register_type = this.register_type;
                    return i;
                });

                let mobiles = [];
                let name_mapping = {};

                this.accounts.forEach(account => {
                    mobiles.push(account.mobile);
                    name_mapping[account.mobile] = account.real_name;
                })


                if (mobiles.length > 0) {

                    AccountService.checkExists({customer_id: this.customer.id, mobiles: mobiles}).then(rs => {

                        if (rs.data && rs.data.length > 0) {
                            this.innerVisible = true;
                            let existUsers = [];
                            this.existMobiles = [];
                            rs.data.forEach(row => {
                                if (name_mapping[row.mobile]) {
                                    row['name'] = name_mapping[row.mobile];
                                }
                                existUsers.push(row);
                                this.existMobiles.push(row.mobile);
                            })

                            this.existUsers = existUsers;

                            return false;
                        }

                        return AccountService.batchRegister(this.accounts);

                    }).then(res => {

                        if (res == false) {
                            this.submiting = false;
                            return;
                        }

                        this.submiting = false;
                        if (res.code == 0) {
                            this.$message.success("注册成功");
                            this.close(true);
                        }

                        if (res.code == 4002) { //短信未发送成功的需要展示出来
                            this.showFailForm = true;
                            this.sms_fail = res.data;
                        }
                    }).catch(err => {
                        console.error(err)
                        this.submiting = false;
                    })
                }
            },

            handleEnforceBatchRegister() {
                this.submiting = true;
                AccountService.batchRegister(this.accounts).then(res => {

                    if (res == false) {
                        this.submiting = false;
                        return;
                    }

                    this.submiting = false;
                    if (res.code == 0) {
                        this.$message.success("注册成功");
                        this.close(true);
                    }

                    if (res.code == 4002) { //短信未发送成功的需要展示出来
                        this.showFailForm = true;
                        this.sms_fail = res.data;
                    }
                }).catch(err => {
                    console.error(err)
                    this.submiting = false;
                })
            },


            handleClose() {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？", "温馨提示", {type: "warning"}).then(ok => {
                    this.close();
                }).catch(cancel => {
                    return false;
                });
            },

            handleSendPassword(account) {
                let model = {
                    user_id: account.user_id,
                    customer_id: account.customer_id,
                    username: account.username,
                    real_name: account.real_name,
                    mobile: account.mobile
                };
                this.$confirm('此操作会将新密码发送到此用户绑定手机上,确认发送？', '温馨提示', {type: "warning"}).then(() => {
                        AccountService.resetPasswordSms(model).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: "密码发送成功,密码已发生至绑定手机：【" + account.mobile + "]上,请注意查收",
                                    type: "success",
                                    showClose: true,
                                });
                                this.sms_fail = this.sms_fail.filter(i => {
                                    return i.mobile != model.mobile;
                                });
                                if (this.sms_fail.length == 0) {
                                    this.showFailForm = false;
                                    this.close(true);
                                }
                            } else {
                                this.$message.error(res.msg);
                                return false;
                            }
                        })
                    }
                );
            },

            close(status = false) {
                this.showImport = false;
                this.showForm = false;
                this.accounts = [];
                this.$emit("callback", status);
            },

            handleSelectionChange(accounts) {
                this.selections = accounts;
            },

            /***
             * 批量移除
             */
            removeAccounts() {
                if (this.selections.length < 1) {
                    this.$message.error("请先选择要移除的数据");
                    return;
                }

                this.$confirm("确定要移选中的这些记录？", "温馨提示", {type: "warning"}).then(ok => {
                    this.selections.forEach(account => {
                        this.accounts.splice(this.accounts.indexOf(account), 1);
                    })
                }).catch(cancel => {
                    return false;
                });
            },

            changeType(){
                this.fileList = [];
                this.importText = '';
            },

            isAllRowsWhite() {
                const rows = this.accounts; // 获取表格数据
                for (const row of rows) {
                    const className = this.tableRowClassName({ row }); // 获取当前行的类名
                    // console.log(className, className === 'error-row' || className === 'warning-row' || className === 'info-row', row);
                    if (className === 'error-row' || className === 'warning-row' || className === 'info-row') {
                        this.showWarning = true;
                        return false; // 如果存在非白色背景的类名，返回 false
                    }
                }
                this.showWarning = false;
                return true; // 所有行都是白色背景
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/dialog/RegAccounts.vue